import { getColor } from '@/utils/theme/colors';
import { Box, Grid } from '@mui/material';
import { Thumbnail } from '../Inclusions/modal';
import FlexBox from '@/atomic-components/FlexBox';

type ImageThumbnailSelectorProps = {
	images: Thumbnail[];
	currentIndex: number;
	onImageSelection: (image: Thumbnail, index: number) => void;
};

const ImageThumbnailSelector = (props: ImageThumbnailSelectorProps) => {
	return (
		<>
			{props.images?.map((item, index) => {
				return (
					<Box
						key={item.url}
						height='50px'
						marginRight='8px'
						sx={{
							cursor: 'pointer',
							border: `${
								props.currentIndex === index + 2
									? `2px solid ${getColor('Minty 0')}`
									: 'none'
							}`,
						}}
						onClick={() => props.onImageSelection(item, index)}
					>
						<img style={{ height: '100%' }} src={item.url} alt='' />
					</Box>
				);
			})}
		</>
	);
};

export default ImageThumbnailSelector;
